import { struct, union } from 'io-ts/Decoder';

import { Scopes } from '../../../../../acs/Scopes';
import { Id as UserId } from '../../../../../user/Id';

export const Request = union(struct({ scopes: Scopes }), struct({ userId: UserId }));
